// Image paths - using public folder paths
export const udangImg = '/assets/udang.png';
export const anomasImg = '/assets/anomas.png';
export const anomapenyihirImg = '/assets/anomapenyihir.png';
export const paluImg = '/assets/anomapalu.png';
export const backgroundImg = '/assets/bckgrond.png';
export const ripImg = '/assets/rip.png';
export const jamImg = '/assets/jam.png';
export const coinImg = '/assets/coin.png';
export const anoma1Img = '/assets/anoma1.png';
export const anoma2Img = '/assets/anoma2.png';
export const anoma3Img = '/assets/anoma3.png';
export const anoma4Img = '/assets/anoma4.png';
export const shrimpersImg = '/assets/SHRIMPERS.png';
export const shrimpers1Img = '/assets/SHRIMPERS1.png';
export const shrimpers2Img = '/assets/SHRIMPERS2.png';
export const shrimpers3Img = '/assets/SHRIMPERS3.png';

